import {PersianKeyValue} from './SamanHealthFamilyModels';
import {Scenario, StaticMethods} from './GeneralModels';

export class IndividualAccidentsOffer {
  public id: number;
  public offerName: number;
  public services: PersianKeyValue[];
  public costs: any;
  public companyName: number;
  public discountsList: string[];
  public icon: string;
  constructor(data, durations) {
    this.id = data.id;
    this.offerName = data.offerName;
    this.services = [];
    for (const serviceKey in data.services) {
      if (!data.services.hasOwnProperty(serviceKey)) {
        continue;
      }
      this.services[this.services.length] = new PersianKeyValue(StaticMethods.numberWithCommas(data.services[serviceKey]), serviceKey);
    }
    this.costs = {};
    durations.forEach(duration => {
      if (data.costs[duration]) {
        console.log(data.costs[duration].originalPrice);
        // const originalPrice = StaticMethods.numberWithCommas(data.costs[duration].originalPrice);
        // const price = StaticMethods.numberWithCommas(data.costs[duration].price);
        this.costs[duration] = new Cost(data.costs[duration].price, data.costs[duration].originalPrice, data.costs[duration].discountsList);
      }
    });
    this.costs = data.costs;
    this.companyName = data.companyName;
    this.discountsList = data.discountsList;
    this.icon = 'ico-person-outline';
  }
}

export class Cost {
  constructor(public price: number, public originalPrice: number, public discountList: string[]) {
    console.log(this.price);
  }
}

export class IndividualAccidentsRequest {
  public id: number;
  public age: number;
  public gender: string;
  public offerName: string;
  public FormsSubmission: boolean;
  public paid: boolean;
  public status: boolean;
  public insuranceReleased: boolean;
  public currentStep: string;
  public viewArray: any;

  constructor(data: any, scenario: Scenario) {
    this.id = data.id;
    this.age = data.age;
    this.gender = data.gender;
    this.offerName = data.offerName;
    this.FormsSubmission = data.formSubmitted;
    this.paid = data.paid;
    this.insuranceReleased = data.insuranceReleased;
    this.currentStep = StaticMethods.setStep(scenario, this.checkStepStatus, this);
    this.viewArray = {
      requestID: this.id,
      age: this.age,
      offer: this.offerName,
      FormsSubmission: this.FormsSubmission,
      paid_label: this.paid ? 'true_payment' : 'false_payment',
      status: this.currentStep
    };
  }

  private checkStepStatus = (step: string, object: IndividualAccidentsRequest): boolean => {
    switch (step) {
      case IndividualAccidentsScenario.formSubmitted:
        return object.FormsSubmission;
      case IndividualAccidentsScenario.paid:
        return object.paid;
      case IndividualAccidentsScenario.waitingForRelease:
        return object.insuranceReleased;
      case IndividualAccidentsScenario.insuranceReleased:
        return !object.insuranceReleased;
    }
  }
}


export class IndividualAccidentsScenario {
  static readonly formSubmitted = 'formSubmitted';
  static readonly paid = 'paid';
  static readonly waitingForRelease = 'waitingForRelease';
  static readonly insuranceReleased = 'insuranceReleased';
  static generalScenario = new Scenario([
    IndividualAccidentsScenario.formSubmitted,
    IndividualAccidentsScenario.paid,
    IndividualAccidentsScenario.waitingForRelease,
    IndividualAccidentsScenario.insuranceReleased,
  ]);
  static B2BScenario = new Scenario([
    IndividualAccidentsScenario.formSubmitted,
    IndividualAccidentsScenario.paid,
    IndividualAccidentsScenario.waitingForRelease,
    IndividualAccidentsScenario.insuranceReleased,
  ]);

  constructor() {
  }
}
